import block from 'bem-cn-lite';

const b = block('input-file');

function renderNoChoosedFile() {
	return `<div class=${b('preview')}>
				<div class=${b('info-value')}>
					No file selected for upload
				</div>
			</div>`;
}

function renderPreviewError(text) {
	return `<div class=${b('preview')}>
				<div class=${b('column')}>
					<div class=${b('error')}>
						${text}
					</div>
				</div>
			</div>`;
}

function renderPreviewFile(file) {
	return `<div class=${b('preview')}>
            	<div class=${b('column')}>
					${file.name ? `<div class=${b('info')}>
                    	<span class=${b('info-label')}>Selected file:</span>
                    	<span class=${b('info-value')}>${file.name}</span>
                	</div>
                	<div class=${b('info')}>
                    	<span class=${b('info-label')}>File size:</span>
                    	<span class=${b('info-value')}>${(file.size / 1000000).toFixed(2)}Mb</span>
					</div>` : ''}
            	</div>
            	<div class=${b('column')}>
                	<img src=${file.url} class=${b('image')} alt=""/>
            	</div>
        	</div>`;
}

(function () {
	const InputFiles = [].slice.call(document.querySelectorAll('.js-input-file'));

	InputFiles.forEach(inputFile => {
		const input = inputFile.querySelector('.input-file__input');
		const helper = inputFile.querySelector('.js-input-file-helper');
		const maxSize = input.getAttribute('size');
		const currentImageUrl = input.getAttribute('url');
		const previewContainter = document.createElement('div');

		previewContainter.innerHTML = renderNoChoosedFile();

		inputFile.appendChild(previewContainter);

		if (currentImageUrl) {
			previewContainter.innerHTML = renderPreviewFile({url: currentImageUrl});
			helper.style.display = 'none';
		}

		input.addEventListener('change', event => {
			const files = [].slice.call(event.target.files);

			let preview = '';

			files.forEach((file, i) => {
				files[i].url = URL.createObjectURL(file);
				if (file.size > maxSize) {
					const errorText = `The file ${file.name} more than ${(maxSize / 1000000).toFixed(2)}Mb`;

					preview += renderPreviewError(errorText);
				} else {
					preview += renderPreviewFile(file);
				}
			});

			if (!event.target.files.length) {
				previewContainter.innerHTML = renderNoChoosedFile();
				helper.style.display = 'block';
				return;
			}

			previewContainter.innerHTML = preview;
			helper.style.display = 'none';
		});
	});
}());
